/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
var shippingTermsValue = false;
var signatureValue = false;
var listenerSet = false;
document.addEventListener("DOMContentLoaded", function(){
    var checkbox = document.querySelector('.product-form__line-item-property input[type=checkbox].property_link_checkbox_1');
    var checkboxTwo = document.querySelector('.product-form__line-item-property input[type=checkbox].property_link_checkbox_2');
    var checkbox_3 = document.querySelector('.product-form__line-item-property input[type=checkbox].property_link_checkbox_3');
    var checkbox_4 = document.querySelector('.product-form__line-item-property input[type=checkbox].property_link_checkbox_4');
    var dataId, dataIdTwo, dataId_3, dataId_4;
    
    if(typeof checkbox != "undefined" && checkbox != null || typeof checkboxTwo != "undefined" && checkboxTwo != null || typeof checkbox_3 != "undefined" && checkbox_3 != null || typeof checkbox_4 != "undefined" && checkbox_4 != null) {
        document.addEventListener('variant:added', function(event) {
           var variant = event.detail.variant; // Get the variant that was added
           
           var tempData;
           let formData = {
            'items': []
           };

           if(typeof checkbox != "undefined" && checkbox != null) {
                dataId = checkbox.dataset.productId;
                if(checkbox.checked && variant.id != dataId && dataId != '') {
                  tempData = {
                    'id': dataId,
                    'quantity': variant.quantity,
                    'properties': {
                      'For SKU': variant.sku
                    }
                  };
                  formData.items.push(tempData);
                }
            }
            
            if(typeof checkboxTwo != "undefined" && checkboxTwo != null) {
              
              dataIdTwo = checkboxTwo.dataset.productId;
              if(checkboxTwo.checked && variant.id != dataIdTwo && dataIdTwo != '') {
                tempData = {
                  'id': dataIdTwo,
                  'quantity': variant.quantity,
                  'properties': {
                    'For SKU': variant.sku
                  }
                };
                formData.items.push(tempData);
              }
            }

            if(typeof checkbox_3 != "undefined" && checkbox_3 != null) {
              dataId_3 = checkbox_3.dataset.productId;
              if(checkbox_3.checked && variant.id != dataId_3 && dataId_3 != '') {
              tempData = {
                'id': dataId_3,
                'quantity': variant.quantity,
                'properties': {
                  'For SKU': variant.sku
                }
              };
              formData.items.push(tempData);
              }
            }

            if(typeof checkbox_4 != "undefined" && checkbox_4 != null) {
              dataId_4 = checkbox_4.dataset.productId;
              if(checkbox_4.checked && variant.id != dataId_4 && dataId_4 != '') {
              tempData = {
                'id': dataId_4,
                'quantity': variant.quantity,
                'properties': {
                  'For SKU': variant.sku
                }
              };
              formData.items.push(tempData);
              }
            }
          
          if(formData.items.length > 0) {        
            
            fetch( window.themeVariables.routes.cartAddUrl + '.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
            })
            .then(response => {
              return response.json();
            })
            .catch((error) => {
              console.error('Error:', error);
            });
            
           }
    
        });
        
        document.addEventListener('cart:updated', function(event) {
            var cart = event.detail.cart; // Get the updated content of the cart
            console.log(cart);
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: {
                    cart: cart
                }
            }));
            
        });

      }

      
  //Cart checkboxes
  var minicart = document.getElementById('mini-cart');

  if(typeof minicart != 'undefined' && minicart != null) {
    console.log("mini cart exists");    
    
    // Options for the observer (which mutations to observe)
    const config = { attributes: true, childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        
        if (mutation.type == "childList") {
          console.log(mutation);
          if(mutation.target.classList.contains('mini-cart')) {
            init_cart_checkboxes();
          }
        } else if (mutation.type == "attributes") {
          if(mutation.target.classList.contains('mini-cart')) {
            init_cart_checkboxes();
          }
        }
      }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(minicart, config);
    
  }

});

function init_cart_checkboxes() {
  console.log("init checkboxes");
  var shippingTerms = document.querySelector('#shipping-terms');
  var signature = document.querySelector('#signature');
  var shippingTermsLink = document.querySelector('.open-shipping-terms');
  var shippingDrawer = document.getElementById('shipping-terms-drawer');
  var signatureLink = document.querySelector('.open-signature');
  var signatureDrawer = document.getElementById('signature-drawer');
  var checkoutButton = document.querySelector('.checkout-button');
  var disclaimer = document.querySelector('.cart-disclaimer');


  if(typeof shippingTerms != 'undefined' && shippingTerms != null && typeof signature != 'undefined' && signature != null) {
    if(shippingTermsValue == true) {
      shippingTerms.checked = true;
      checkoutButton.disabled = false;
      disclaimer.style.display = 'none';
    }

    if(signatureValue == true) {
      signature.checked = true
    }

    shippingTerms.addEventListener('change', function(e){
      if (e.currentTarget.checked) {
        shippingTermsValue = true;
        checkoutButton.disabled = false;
        disclaimer.style.display = 'none';
      } else {
        shippingTermsValue = false;
        checkoutButton.disabled = true;
        disclaimer.style.display = 'block';
      }
    });

    signature.addEventListener('change', function(e){
      if (e.currentTarget.checked) {
        signatureValue = true;
        jQuery.post(window.themeVariables.routes.cartUrl+ '/update.js', "attributes[Required signature]=Yes").done(console.log('all set'));
      } else {
        signatureValue = false;
        jQuery.post(window.themeVariables.routes.cartUrl + '/update.js', "attributes[Required signature]=No").done(console.log('all set'));
      }
    });

    shippingTermsLink.addEventListener('click', function(e){
      e.preventDefault();
      
      shippingDrawer.open = true;
    });
    
    signatureLink.addEventListener('click', function(e){
      e.preventDefault();
      
      signatureDrawer.open = true;
    });
  }
}

var BrowserDetect = {
  init: function () {
      this.browser = this.searchString(this.dataBrowser) || "Other";
      this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "Unknown";
  },
  searchString: function (data) {
      for (var i = 0; i < data.length; i++) {
          var dataString = data[i].string;
          this.versionSearchString = data[i].subString;

          if (dataString.indexOf(data[i].subString) !== -1) {
              return data[i].identity;
          }
      }
  },
  searchVersion: function (dataString) {
      var index = dataString.indexOf(this.versionSearchString);
      if (index === -1) {
          return;
      }

      var rv = dataString.indexOf("rv:");
      if (this.versionSearchString === "Trident" && rv !== -1) {
          return parseFloat(dataString.substring(rv + 3));
      } else {
          return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
      }
  },

  dataBrowser: [
      {string: navigator.userAgent, subString: "Edge", identity: "MS Edge"},
      {string: navigator.userAgent, subString: "MSIE", identity: "Explorer"},
      {string: navigator.userAgent, subString: "Trident", identity: "Explorer"},
      {string: navigator.userAgent, subString: "Firefox", identity: "Firefox"},
      {string: navigator.userAgent, subString: "Opera", identity: "Opera"},  
      {string: navigator.userAgent, subString: "OPR", identity: "Opera"},  

      {string: navigator.userAgent, subString: "Chrome", identity: "Chrome"}, 
      {string: navigator.userAgent, subString: "Safari", identity: "Safari"}       
  ]
};

BrowserDetect.init();

if(BrowserDetect.browser == 'Safari') {
  document.body.classList.add('safari-browser');
}